import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const Styled = styled(Box)(({ theme }) => ({
  "& .heading": {
    borderTop: "3px solid",
    borderBottom: "3px solid",
    borderColor: theme.palette.primary.main,
    padding: "0.625rem",
    marginTop: "0.9375rem",
    "& .MuiTypography-root": {
      fontWeight: "600",
    },
  },
  "& .docContainer": {
    position: "relative",
    transition: "all 0.3s ease-out",
    padding: ".7rem 0.5rem 0.7rem 1rem",
    "&:hover, &:focus-within": {
      "& .clickable": {
        cursor: "pointer",
        "& .MuiTypography-root": {
          color: "#71cbf5",
          ...theme.applyStyles("light", {
            color: "#337ab7",
          }),
        },
      },
    },
  },
  "& .label": {
    fontSize: "0.90rem",
    padding: "0.5rem 0",
    textShadow: "none",
    color: "unset",
    "& .attachFileIcon": {
      fontSize: "1.2rem",
      transform: "rotate(140deg)",
      verticalAlign: "sub",
      marginRight: "0.3125rem",
    },
    "& .protipIcon": {
      margin: "0 0 0.25rem 0.5rem",
      padding: 0,
    },
    ...theme.applyStyles("light", {
      color: "#000",
    }),
  },
  "& .uploadBtn": {
    boxShadow: "0 2px 5px 0 rgb(0 0 0 / 26%)",
    margin: "0 0 0 1rem",
  },
  "& .toggleBtn": {
    "& .MuiSvgIcon-root": {
      color: "#71cbf5",
      ...theme.applyStyles("light", {
        color: "#337ab7",
      }),
    },
    top: "12%",
    right: "-2px",
  },
  [theme.breakpoints.down("sm")]: {
    "& .container": { padding: ".7rem 0.5rem 0.7rem 0.2rem" },
    "& .uploadBtn": { width: "100%", margin: "0.8rem 0 0 0" },
    "& .toggleBtn": { position: "absolute" },
  },
}));

export const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "marginLeft" && prop !== "isLastItem",
})(({ theme }) => ({
  borderBottom: "1.5px solid #d8d8d8",
  padding: "0.75rem 0",
  "& .labelContainer": {
    display: "flex",
    "& .MuiSvgIcon-root": {
      marginRight: ".5rem",
    },
  },
  "& .textWrapper": {
    marginLeft: "unset",
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    "& .MuiTypography-root:first-of-type": {
      fontSize: "0.88rem",
      fontWeight: 500,
      textShadow: "none",
      flex: 2.2,
      ...theme.applyStyles("light", {
        fontWeight: 600,
      }),
    },
    "& .MuiTypography-root:nth-of-type(2)": {
      color: "#71cbf5",
      fontSize: "0.88rem",
      flex: 1,

      ...theme.applyStyles("light", {
        color: undefined,
      }),
    },
  },
  "& .statusItem": {
    flex: 1,
    "& .MuiTypography-root": {
      fontSize: "0.88rem",
      fontWeight: "400 !important",
      color: "#71cbf5",
      ...theme.applyStyles("light", {
        color: undefined,
      }),
    },
  },
  "& .docToggleBtn": {
    fontSize: "0.88rem",
    padding: "0",
    color: undefined,
    textTransform: "unset",
    fontWeight: 400,
    "&:hover": {
      background: "transparent",
    },
    ...theme.applyStyles("light", {
      color: "#337ab7",
    }),
  },
  "& .collapseWrapper": {
    display: "block",
    width: "60%",
    "& .muiStack": {
      paddingTop: ".5rem",
      flexWrap: "wrap",
      "& .MuiChip-root": {
        marginRight: ".5rem",
        marginBottom: "0.625rem",
        color: "#71cbf5",
        "&:hover": {
          cursor: "pointer",
          textDecoration: "underline",
        },
        ...theme.applyStyles("light", {
          color: "#337ab7",
        }),
      },
    },
  },
  [theme.breakpoints.down("sm")]: {
    padding: "0.1rem 0",
    "& .textWrapper": { display: "block" },
    "& .docToggleBtn": { padding: "0.25rem 0" },
    "& .collapseWrapper": { width: "100%" },
  },
  variants: [
    {
      props: ({ marginLeft }) => marginLeft,
      style: {
        "& .textWrapper": {
          marginLeft: "2rem",
        },
      },
    },
  ],
}));

export const StyledTable = styled(Box)(({ theme }) => ({
  "& .MuiTableHead-root": {
    "& .MuiTableCell-root": {
      whiteSpace: "nowrap",
    },
  },
  "& .MuiTableBody-root": {
    "& .MuiTableRow-root": {
      "&:last-child td, &:last-child th": { border: 0 },
    },
    "& .MuiTableCell-root": { padding: "0.5rem", paddingLeft: "0" },

    "& .MuiIconButton-root": {
      padding: "0 0.25rem 0 0",
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    "& .customLink": {
      "&:hover": {
        cursor: "pointer",
      },
    },
  },
  "& .MuiTableCell-root": {
    paddingLeft: "0",
    fontSize: "0.75rem",
  },
  "& .visuallyHidden": {
    width: "11.25rem",
    visibility: "hidden",
  },
  "& .actions": {
    width: "11.25rem",
  },
  [theme.breakpoints.down("sm")]: {
    "& .visuallyHidden": { width: "unset" },
    "& .actions": { width: "unset", minWidth: "5.9375rem" },
  },
}));

export const StyledPreviewContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isLoading",
})({
  height: "99%",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "unset",
  "& .wrapper": {
    display: "flex",
    height: "100%",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    "& > img": {
      maxHeight: "100%",
      maxWidth: "100%",
      objectFit: "contain",
    },
  },
  "& .info": {
    display: "flex",
    justifyContent: "center",
  },

  variants: [
    {
      props: ({ isLoading }) => isLoading,
      style: { position: "relative", "& .wrapper": { display: "none" } },
    },
  ],
});

export const StyledDiv = styled(Box)(({ theme }) => ({
  display: "flex",
  marginTop: "1rem",

  "& .imgContainer": {
    display: "flex",
    "& .imgLabel": {
      fontSize: "0.88rem",
      fontWeight: 500,
      textShadow: "none",
      paddingTop: "0.125rem",
      ...theme.applyStyles("light", {
        fontWeight: 600,
      }),
    },
    "& img": {
      maxHeight: "12.5rem",
      margin: "0 auto",
      display: "block",
    },
  },
  "& .MuiFormControlLabel-root": {
    alignItems: "flex-start",
    "& .MuiCheckbox-root": {
      padding: "0 0.625rem 0 0",
      "&:hover": {
        backgroundColor: "transparent",
      },
      "&.Mui-checked": {
        color: theme.palette.primary.main,
        ...theme.applyStyles("light", {
          color: "rgba(255,87,34,0.87)",
        }),
      },
    },
    "& .MuiTypography-root": {
      fontSize: "0.9rem",
    },
  },
  "& .MuiFormHelperText-root": {
    marginLeft: 0,
    marginTop: "1rem",
  },
  [theme.breakpoints.down("sm")]: {
    "& .imgContainer": {
      display: "block",
      "& img": {
        margin: "0.625rem auto",
      },
    },
    "& .MuiFormControlLabel-root": {
      marginLeft: "-2rem",
    },
  },
}));
